import * as types from "./emitir.actionTypes";

export default {
  setTokenRecaptcha: data => ({
    type: types.SET_TOKEN_RECAPTCHA,
    payload: data
  }),
  save: data => ({
    type: types.SAVE,
    payload: data
  })
};
